import { render, staticRenderFns } from "./AgentSelector.vue?vue&type=template&id=23956ce9&scoped=true&"
import script from "./AgentSelector.vue?vue&type=script&lang=js&"
export * from "./AgentSelector.vue?vue&type=script&lang=js&"
import style0 from "./AgentSelector.vue?vue&type=style&index=0&id=23956ce9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23956ce9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23956ce9')) {
      api.createRecord('23956ce9', component.options)
    } else {
      api.reload('23956ce9', component.options)
    }
    module.hot.accept("./AgentSelector.vue?vue&type=template&id=23956ce9&scoped=true&", function () {
      api.rerender('23956ce9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/conversationBulkActions/AgentSelector.vue"
export default component.exports